// Small text helpers shared by the screens that show points.

import { signed } from "../shared/text";

export { signed };

/** "today +3" / "today −2" / "today 0". */
export function todayLine(net: number): string {
  return `today ${signed(net)}`;
}

/**
 * The review headline: "93 · goal 90 · star day", "84 · goal 90 · 6 to go" while the day is
 * open, or "84 · goal 90 · no star" once it is closed and there is nothing left to go for.
 */
export function reviewLine(score: number, goal: number, closed: boolean): string {
  const verdict = score >= goal ? "star day" : closed ? "no star" : `${goal - score} to go`;
  // No-break spaces everywhere but after each dot, so a narrow phone wraps only there and the
  // dot stays at the end of the line it follows.
  return [String(score), `goal ${goal}`, verdict].map((part) => part.replaceAll(" ", "\u00a0")).join("\u00a0· ");
}

/** A YYYY-MM-DD day key written out in British English, e.g. { month: "short" } for "Oct". */
export function formatDay(day: string, opts: Intl.DateTimeFormatOptions): string {
  // Noon UTC is the same calendar date everywhere, so the key's own date is what gets named.
  return new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", ...opts }).format(new Date(day + "T12:00:00Z"));
}

/** "Sat 10 Oct" for a YYYY-MM-DD day key. */
export function shortDate(day: string): string {
  return formatDay(day, { weekday: "short", day: "numeric", month: "short" });
}

/** "Saturday 10 October" for a YYYY-MM-DD day key. */
export function longDate(day: string): string {
  return formatDay(day, { weekday: "long", day: "numeric", month: "long" });
}

/** "October 2026" for a YYYY-MM month key. */
export function monthTitle(month: string): string {
  return new Intl.DateTimeFormat("en-GB", { timeZone: "UTC", month: "long", year: "numeric" }).format(
    new Date(month + "-15T12:00:00Z"),
  );
}
